import type { KadeweUser } from "~/types";

export default defineNuxtRouteMiddleware((to) => {
    const user = useSanctumUser<KadeweUser>();
    const localePath = useLocalePath();

    if (
        user.value?.contact_id &&
        !(user.value?.missing_profile_fields?.length > 0) &&
        to.path === localePath("/register/complete-profile")
    ) {
        console.warn("Account incomplete: User has already completed their account", to.path);
        return navigateTo(localePath("/portal/card"));
    }

    if (
        to.path === localePath("/register/merge/complete-profile") &&
        !((user.value?.missing_profile_fields?.length ?? 0) > 0)
    ) {
        console.warn("Account incomplete: Merge user has no missing profile fields", to.path);
        return navigateTo(localePath("/portal/card"));
    }
});
